import React from 'react';

export const GlobalModalContext = React.createContext();
